import { useTranslation } from "react-i18next";

import { Alert } from "./v2/ui/alert";

/**
 * Stands in for the answer while a customer request's or the general notes' changed
 * facts are unconfirmed (#820). Venus shows the requests beside the answer, so there
 * is no way back to offer. A notice that is part of the page's state, not an event, so
 * it is not announced as one.
 */
export function AnswerHeldBackNotice() {
  const { t } = useTranslation();
  return (
    <Alert tone="info" announce={false}>
      {t(
        "requestFactsConfirmation.heldBack",
        "Die Fakten wurden geändert. Bitte bestätigen Sie die Änderungen bei den Kundenanliegen, um die Antwort anzuzeigen.",
      )}
    </Alert>
  );
}
